import { Injectable } from '@angular/core';

export interface MobileAppServiceInterface {
  isAndroid(): boolean;
  isIos(): boolean;
}

@Injectable()
export class MobileAppService implements MobileAppServiceInterface {

  private userAgent: string;

  constructor() {
    this.userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
  }

  isAndroid(): boolean {
    return /android/i.test(this.userAgent);
  }

  isIos(): boolean {
    return /iPad|iPhone|iPod/.test(this.userAgent);
  }
}
